exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".toasted.bubble{background-color:#094074!important;font-weight:400!important}@media screen and (max-width:600px){.toasted.bubble{padding:10px 20px!important}}.toasted.bubble .action{color:#90a7ca!important;transition:color .5s}.toasted.bubble .action:hover{color:#fff!important}.install_loading{z-index:100000;transform:translateY(-35px)}.loading_icon{font-size:160%;padding:8px 0}", ""]);

// exports
